export enum ChangeType {
  deleted = 'deleted',
  edited = 'edited',
  created = 'created',
  receivedFromDB = 'receivedFromDB'
}
